import { useAppDispatch } from '@/shared/lib/redux'
import { IBooking } from '@/shared/api/aviabooking'
import { openAcknowledgeModal } from '../model'

export const useAcknowledgePriceChangeModal = () => {
    const dispatch = useAppDispatch()

    const openModal = (booking: IBooking, onAcknowledge?: () => void) => {
        dispatch(openAcknowledgeModal({
            booking,
            onAcknowledge
        }))
    }

    return {
        openModal,
    }
}